import dayjs from "dayjs"

export const filters = {
	formatDate(value, format = "DD MMM YYYY") {
		if (!value) return ""
		return dayjs(value).format(format)
	},

	formatAmount(value) {
		if (value == null) return "—"
		const numValue = typeof value === 'string' ? parseFloat(value) : value
		if (isNaN(numValue)) return "—"
		return new Intl.NumberFormat("en-IN", {
			minimumFractionDigits: 0,
			maximumFractionDigits: 2
		}).format(numValue)
	},
	
	formatTenureFromDays(days: number): string {
		if (!days || days <= 0) return "0M"; // fallback for invalid or zero days
	
		const YEAR = 365; // Approximate year length in days
		const MONTH = 30; // Approximate month length in days
	
		// Handle years first
		let years = Math.floor(days / YEAR);
		const remainingDaysAfterYears = days % YEAR;
	
		// Handle months from the remaining days after calculating years
		let months = Math.floor(remainingDaysAfterYears / MONTH);
	
		// If months is 12 or more, convert them into a year
		if (months >= 12) {
			years += Math.floor(months / 12);
			months = months % 12; // keep remainder months
		}
	
		// Handle remaining days after calculating months
		const remainingDays = remainingDaysAfterYears % MONTH;
	
		let result = "";
	
		if (years > 0) {
			result += `${years}Y`;
		}
	
		if (months > 0) {
			result += ` ${months}M`;
		}
	
		if (remainingDays > 0 && years === 0 && months === 0) {
			result += `${remainingDays}D`; // show days only if no years or months
		}
		return result.trim();
	}
}
